<template>
  <div class="trend-view-wrapper pl-15px pr-15px pb-10px" id="trendView" v-if="trendDialog">
    <div class="h-full">
      <dialogTitle
        @on-toggle="toggleSmallDialog"
        @on-fullscreen="toggleScreen"
        @on-close="closeDialog"
      />
      <search
        :search="search"
        :status="status"
        :trendTableData="trendTableData"
        :updateTime="updateTime"
        @on-print="doPrint"
        @on-select="handleSelect"
        @on-switch="switchChange"
        @on-search="searchHistoryTrend"
      />
      <div
        style="height: calc(100% - 348px);width:100%;"
        id="chartLine"
        :key="chartKey"
        v-loading="lineLoading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
      ></div>
      <trendTable
        ref="trendTable"
        :selected="selected"
        :colorIndex="colorIndex"
        :trendTableData="trendTableData"
        :lineWidth="lineWidth"
        :lineStyle="lineStyle"
        :colorBar="colorBar"
        :lineStyleOptions="lineStyleOptions"
        :widthOptions="widthOptions"
        @on-setStyle="setStyle"
        @on-setColorIndex="setColorIndex"
        @on-showColorBar="showColorBar"
        @on-select="tableSelectChange"
        @on-delete="deletePoint"
        @on-saveYAxis="saveYAxis"
      />
    </div>
    <smallDialogComponent
      :smallDialogShow="smallDialog"
      :tagIdTbData="tagIdTbData"
      @on-toggle="toggleSmallDialog"
      @on-close="closeLockWin"
      @on-delete="deleteTagId"
    />
    <div
      style="position:absolute;top: -9999999px;left: -999999px;width:600px;height:400px;"
      id="unshowEcharts"
    ></div>
  </div>
</template>

<script type="text/babel">
import { IotApi } from '@wiz-api/measuring-point-management'
import dayjs from 'dayjs'
import search from './components/search'
import trendTable from './components/table'
import smallDialogComponent from './components/smallDialog'
import dialogTitle from './components/title'

const iotApi = new IotApi()

export default {
  name: 'trendview-dialog',
  components: {
    search,
    trendTable,
    smallDialogComponent,
    dialogTitle,
  },
  props: {
    /* 测点数据; code name id pointId为必传
     [
      {
        code: 'xxxx', // String
        name: 'xxx', // String
        id: 'xx-xxxx-xxx-xx', // String
        pointId: 123, // Number
      }
     ]
    */
    measurePoints: {
      type: Array,
      default: () => {
        return []
      },
    },
    startTime: String, // '2023.01.16 12:30:30'
    endTime: String, // '2023.02.16 12:30:30'
    /* status: 查看模式; 0 = 实时模式；1 = 历史模式 */
    status: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isFullScreen: false, // 是否全屏
      updateTime: 123213,
      trendDialog: true,
      smallDialog: false,
      tagIdTbData: [], // 表格数据ID集合
      yAxisValue: [],
      echartOption: {
        animation: false,
        color: [
          '#3f51b5',
          '#e51c23',
          '#009688',
          '#259b24',
          '#ff9800',
          '#8129bd',
          '#b5c334',
          '#fcce10',
          '#e87c25',
          '#27727b',
        ],
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            let formatStr = `${moment(params[0].data[0]).format('YYYY-MM-DD HH:mm:ss')}<br/>`
            _.forEach(params, (item) => {
              formatStr = `${formatStr}${item.marker}${item.seriesName}: ${item.data[1]}<br/>`
            })
            return formatStr
          },
          axisPointer: {
            type: 'cross',
            label: {
              show: true,
              backgroundColor: 'rgba(80, 87, 101, 0.4)',
            },
          },
          show: true,
        },
        grid: {
          left: 35,
          right: 35,
          top: 30,
          bottom: '8%',
          containLabel: true,
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
            zoomOnMouseWheel: true, // 允许使用鼠标滚轮进行缩放
          },
        ],
        xAxis: {
          type: 'time',
          // splitNumber: 6,
          interval: '',
          splitLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#31B6F9',
            },
            showMinLabel: true,
            showMaxLabel: true,
          },
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show: false,
              lineStyle: {
                color: '#38585e',
                type: 'dashed',
              },
            },
          },
        ],
        series: [],
      },
      chartKey: 1546,
      search: {
        status: 0, // 实时/历史
        interval: 1, // 颗粒度数值
        intervalUnit: 0, // 颗粒度单位(秒、分、时、天)
        timeSpan: 0, // 快速选取数值
        time: [], // 开始与结束时间
      },
      trendTableData: [], // 表格里的测点数据
      colorBar: [
        '#FF8000',
        '#FF0000',
        '#00FF00',
        '#0000FF',
        '#00FF80',
        '#00FFFF',
        '#FF00FF',
        '#9ACD32',
        '#009900',
        '#008080',
        '#D87A80',
        '#FFB980',
        '#FC6335',
        '#8A2BE2',
        '#C71585',
        '#0080FF',
      ],
      lineStyle: 'solid',
      lineStyleOptions: [
        {
          label: '实线',
          value: 'solid',
        },
        {
          label: '虚线',
          value: 'dashed',
        },
      ],
      lineWidth: '1',
      widthOptions: [
        {
          label: '1px',
          value: '1',
        },
        {
          label: '2px',
          value: '2',
        },
        {
          label: '3px',
          value: '3',
        },
        {
          label: '4px',
          value: '4',
        },
      ],
      colorIndex: 0,
      chartTimer: true, // 图表数据请求控制标记
      tableTimer: true, // 表格数据请求控制标记
      selected: [], // 表格里已经勾选的测点数据
      chartLine: null, // 图表实例
      restoreCondition: {},
      lineLoading: false, // 图表是否加载中
      maxWidth: 0,
      maxHeight: 0,
    }
  },
  watch: {
    trendDialog(val) {
      if (val) {
        this.smallDialog = false
        return
      }
      this.trendTableData = []
    },
    trendTableData(val) {
      this.tableTimer = !!val.length
    },
    measurePoints() {
      /* 先清空图表 */
      this.chartLine && this.chartLine.clear()
      this.echartOption.series = []
      this.trendTableData = this.measurePoints
      this.selected = this.measurePoints
      this.switchChange(this.search.status)
      // this.loadPropsMeasurePoints()
      // this.handleSelect(val, {
      //   time: [this.startTime, this.endTime],
      //   status: this.status,
      //   interval: 1, // 颗粒度数值
      //   intervalUnit: 0, // 颗粒度单位(秒、分、时、天)
      //   timeSpan: 0, // 快速选取数值
      // })
    },
    startTime(val) {
      this.search.time[0] = val
    },
    endTime(val) {
      this.search.time[1] = val
    },
  },
  methods: {
    // 处理从外部传进来的测点
    loadPropsMeasurePoints() {
      if (Array.isArray(this.measurePoints) && this.measurePoints.length > 0) {
        this.handleSelect(this.measurePoints, {
          time: [this.startTime, this.endTime],
          status: this.status,
          interval: 1, // 颗粒度数值
          intervalUnit: 0, // 颗粒度单位(秒、分、时、天)
          timeSpan: 0, // 快速选取数值
        })
      }
    },
    // 全屏/缩放 查看趋势窗口
    toggleScreen() {
      this.isFullScreen = !this.isFullScreen
      this.$nextTick(() => {
        if (this.chartLine) {
          this.chartLine.resize()
        }
      })
    },
    // 最小化/放大 查询趋势窗口
    toggleSmallDialog(type) {
      if (type === 'shrink') {
        this.tagIdTbData = _.map(this.trendTableData, (o) => {
          return o.code
        })
        // document.getElementsByClassName('v-modal')[0].style.display = 'none'
        this.smallDialog = true
        this.chartTimer = false
        this.tableTimer = false
      } else {
        // document.getElementsByClassName('v-modal')[0].style.display = 'unset'
        this.smallDialog = false
        this.trendDialog = true
        this.chartTimer = true
        this.tableTimer = true
      }
    },
    // 打印
    doPrint() {
      if (this.trendTableData.length === 0) {
        this.$message.warning('请先添加测点!')
        return
      }
      const newWindow = window.open('', '', 'height=768,width=1200,top=200,left=300')
      newWindow.document.title = '趋势查看'
      // 获取图路径
      const echart = this.$echarts.init(document.getElementById('unshowEcharts'))
      echart.clear()
      echart.setOption(this.echartOption)
      const oImgPath = echart.getDataURL({
        type: 'png',
        pixelRadio: 5,
        backgroundColor: '#fff',
      })
      const headHtml = `<div style="margin-bottom:20px;"><span style="margin-right:10px;">状态：${
        this.search.status
      }</span><span style="margin-right:10px;">时间选择：${
        this.search.time.length > 0 ? this.search.time.length[0] : '开始时间'
      }至${
        this.search.time.length > 0 ? this.search.time.length[1] : '结束时间'
      }</span></div><div style='border: 1px solid black;'><img width='100%' height='auto' src='${oImgPath}'></div>`
      newWindow.document.write(headHtml)
      // newWindow.document.write(prnhtml)
      const thData = [
        '测点编码',
        '中文名称',
        '单位',
        '实时值',
        '最大值',
        '最小值',
        '平均值',
        'Y轴自定义',
      ]
      const trData = _.map(this.trendTableData, (o) => {
        return [
          o.code,
          o.name,
          o.unit,
          o.currentValue,
          o.maxValue,
          o.minValue,
          o.avg,
          `${o.minSection}~${o.maxSection}`,
        ]
      })
      const oTable = document.createElement('table')
      oTable.style.marginTop = '20px'
      const oThead = document.createElement('tr')
      let th = ''
      _.forEach(thData, (o) => {
        th += `<th>${o}</th>`
      })
      oThead.innerHTML = th
      oTable.appendChild(oThead)
      _.forEach(trData, (o) => {
        const oTr = document.createElement('tr')
        let tr = ''
        _.forEach(o, (item, index) => {
          if (index === 0) {
            tr += `<td><div style="border:6px solid ${this.echartOption.color[index]};height:0px;width:0px;display:inline-block;"></div><span>${item}</span></td>`
          } else {
            tr += `<td>${item}</td>`
          }
        })
        oTr.innerHTML = tr
        oTable.appendChild(oTr)
      })
      newWindow.document.body.appendChild(oTable)
      this.setPrintSrtyle(newWindow)
      setTimeout(() => {
        newWindow.print()
        newWindow.close()
      }, 30)
    },
    // 设置打印样式
    setPrintSrtyle(newWindow) {
      const oTable = newWindow.document.querySelector('table')
      oTable.border = 1
      oTable.width = '100%'
      oTable.style.textAlign = 'center'
      oTable.style.borderCollapse = 'collapse'
      oTable.marginTop = '10px'
    },
    /* 处理测点弹窗点击确定后返回的测点数据 */
    handleSelect(measurePoints, searchParams) {
      // console.log('0000', measurePoints)
      this.search = searchParams
      if (Array.isArray(measurePoints) && measurePoints.length > 0) {
        measurePoints.forEach((item) => {
          this.handleSelectItem(item)
        })
        /* 所选测点全部添加进表格和this.selected后，统一手动触发表格勾选事件 */
        this.tableSelectChange(this.selected)
      }
    },
    /* 处理单个测点 */
    handleSelectItem(item) {
      let colorList = _.cloneDeep(this.colorBar)
      /* 找出颜色集合中未被占用的颜色数组 */
      _.forEach(this.trendTableData, (o) => {
        colorList = _.difference(colorList, [o.color])
      })
      const params = {
        visible: false,
        color: colorList[0],
        idx: this.trendTableData.length
          ? this.trendTableData[this.trendTableData.length - 1].idx + 1
          : 0,
        minValue: '',
        maxValue: '',
        currentValue: '',
        avg: '',
        minSection: '',
        maxSection: '',
        lineStyle: 'solid',
        lineWidth: '1',
        ...item,
        pointId: item.id,
        tagId: item.pointId,
      }
      /* 表格里最多放16条测点 */
      if (this.trendTableData.length >= 16) {
        return
      }
      this.trendTableData.push(params)
      /* 如果已勾选的测点数量小于10条，则新添加的测点自动勾选 */
      if (this.selected.length <= 10) {
        this.selected.push(params)
        /* toggleRowSelection会触发selection-change事件 */
        this.$refs.trendTable.$refs.trendTable.toggleRowSelection(params, true)
      }
    },
    // 显示颜色板
    showColorBar(row) {
      this.lineStyle = row.lineStyle
      this.lineWidth = row.lineWidth
      _.forEach(this.colorBar, (o, i) => {
        if (o === row.color) {
          this.colorIndex = i
        }
      })
    },
    // 确定测点设置
    setStyle(row) {
      const currentColor = this.colorBar[this.colorIndex]
      const index = _.findIndex(this.echartOption.series, { name: row.name })
      if (index > -1) {
        this.echartOption.series[index].lineStyle = {
          width: this.lineWidth,
          type: this.lineStyle,
        }
        this.echartOption.color[index] = currentColor
      }
      this.chartLine.setOption({
        series: this.echartOption.series,
        color: this.echartOption.color,
      })
      this.trendTableData[row.idx].color = currentColor
      this.trendTableData[row.idx].lineWidth = this.lineWidth
      this.trendTableData[row.idx].lineStyle = this.lineStyle
      this.trendTableData[row.idx].visible = false
    },
    setColorIndex(index) {
      this.colorIndex = index
    },
    // 删除测点
    deletePoint(data) {
      if (this.trendTableData.length === 1) {
        this.$message.warning('至少保留一个测点！')
        return
      }
      /* 从原有表格中找出与当前删除行不同的数据，重新赋值给表格 */
      this.trendTableData = _.differenceWith(this.trendTableData, [data], _.isEqual)
      /* 在已勾选测点中找当前删除的行，如果在已勾选中，需要处理 */
      this.selected = _.differenceWith(this.selected, [data], _.isEqual)
      _.forEach(this.selected, (o) => {
        this.$nextTick(() => {
          // console.log(this.selected)
          this.$refs.trendTable.$refs.trendTable.toggleRowSelection(o, true)
        })
      })
      if (this.search.status * 1 === 1) {
        this.searchHistoryTrend()
      } else {
        /* 如果是实时查看模式，重新查询 */
        this.chartLine.clear()
        this.switchChange(0)
      }
    },
    // 删除已添加的测点
    deleteTagId(point) {
      this.$confirm('删除该测点, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        document.getElementsByClassName('v-modal')[0].style.display = 'none'
        if (this.tagIdTbData.length === 1) {
          this.$message.warning('至少保留一个测点！')
          return
        }
        const current = _.find(this.trendTableData, { code: point })
        this.trendTableData = _.differenceWith(this.trendTableData, [current], _.isEqual)
        this.tagIdTbData = _.map(this.trendTableData, (o) => {
          return o.code
        })
        this.echartOption.series = _.differenceWith(
          this.echartOption.series,
          [_.find(this.echartOption.series, { name: current.name })],
          _.isEqual
        )
      })
    },
    // 格式化曲线tooltip光标值
    formatterFuns() {
      return (params) => {
        if (params.axisDimension === 'y') {
          const idx = _.findIndex(this.yAxisValue, { axisIndex: params.axisIndex })
          if (idx > -1) {
            this.yAxisValue[idx] = params
          } else {
            this.yAxisValue.push(params)
          }
          let formatStr = '\n'
          _.forEach(this.yAxisValue, (o, i) => {
            if (i < this.echartOption.series.length) {
              const item = this.echartOption.series[o.axisIndex] || {}
              if (i % 2 === 1) {
                if (i !== this.yAxisValue.length - 1) {
                  formatStr = `${formatStr}${item.name}: ${o.value.toFixed(4)}\n\n`
                } else {
                  formatStr = `${formatStr}${item.name}: ${o.value.toFixed(4)}`
                }
              } else {
                formatStr = `${formatStr}${item.name}: ${o.value.toFixed(4)}  `
              }
            }
          })
          return formatStr
        }
        return moment(params.value).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    formatterXAxis() {
      return (value) => {
        return `${moment(value).format('HH:mm:ss')}\n${moment(value).format('YYYY-MM-DD')}`
      }
    },
    /* 关闭趋势查看弹窗 */
    closeDialog() {
      this.chartTimer = false
      this.tableTimer = false
      this.yAxisValue = []
      this.trendTableData = [] // 清空已添加的测点
      this.selected = []
      this.search = this.$options.data().search
      this.echartOption = this.$options.data().echartOption
      this.echartOption.tooltip.axisPointer.label.formatter = this.formatterFuns()
      this.echartOption.xAxis.axisLabel.formatter = this.formatterXAxis()
      this.chartLine.clear()
      this.trendDialog = false
      this.$emit('on-close')
    },
    // 关闭最小化的窗口
    closeLockWin() {
      this.smallDialog = false
      this.closeDialog()
    },
    handleTimezone(val) {
      if (_.isArray(val) && val.length) {
        const end = moment(val[1]).unix()
        const start = moment(val[0]).unix()
        if (end - start > 86400) {
          return false
        }
      }
      return true
    },
    // 切换实时、历史模式(实时 = 0，历史 = 1)
    async switchChange(type) {
      if (!this.trendDialog) return
      if (this.trendTableData.length === 0) {
        this.$message.warning('请先添加测点!')
        return
      }
      // 如果添加了测点，但是后来被手动去掉了勾选，给出提示
      if (this.selected.length === 0) {
        this.$message.warning('没有勾选测点，请勾选')
        return
      }
      if (type * 1 === 1) {
        this.searchHistoryTrend() // 历史查看模式
      } else {
        this.searchRealtimeTrend() // 实时查看模式
      }
    },
    /* 实时查看模式 */
    async searchRealtimeTrend() {
      this.chartTimer = true
      this.search.time = [] // 实时模式，查询条件的开始、结束时间置为空
      this.updateTime += 1
      const lineData = await this.getTrendLine()
      this.restoreCondition = {
        status: this.search.status,
        date: this.search.time,
      }
      this.createLine(lineData)
      this.getTableData(false)
    },
    /* 历史查看模式 */
    async searchHistoryTrend() {
      /* 直接点击搜索时做的判断 */
      if (this.trendTableData.length === 0) {
        this.chartLine.clear()
        this.$message.warning('请先添加测点!')
        return
      }
      /* 先清空图表 */
      this.chartLine && this.chartLine.clear()
      this.echartOption.series = []
      /* 如果在实时查看的模式下，点击了搜索，则查看模式要变为历史模式 */
      if (this.search.status * 1 === 0) {
        this.search.status = 1
      }

      /* 如果没有手动选取开始、结束时间，则从快速选取的数值中来读取开始、结束时间 */
      if (!this.search.time.length) {
        const ts = this.computedTimeSpan(this.search.timeSpan)
        this.search.time[0] = moment()
          .subtract(ts.value, ts.date)
          .format('YYYY-MM-DD HH:mm:ss')
        this.search.time[1] = moment().format('YYYY-MM-DD HH:mm:ss')
        this.updateTime += 1
      }
      if (this.search.time.length && !this.search.time[0]) {
        const ts = this.computedTimeSpan(this.search.timeSpan)
        this.search.time[0] = moment()
          .subtract(ts.value, ts.date)
          .format('YYYY-MM-DD HH:mm:ss')
        this.search.time[1] = moment().format('YYYY-MM-DD HH:mm:ss')
        this.updateTime += 1
      }
      this.chartTimer = false
      this.lineLoading = true // 图表加载loading
      const lineData = await this.getTrendLine() // 测点趋势折线图数据
      this.lineLoading = false
      /* 存储查询条件，图表上的复原功能要用到 */
      this.restoreCondition = {
        status: this.search.status,
        date: this.search.time,
      }
      this.createLine(lineData)
      this.getTableData(false) // 测点表格数据
    },
    /* 快速选取 */
    timeSpanChange() {
      this.search.time = [] // 搜索时间置为空
      this.searchHistoryTrend()
    },
    /* 处理鼠标滚动时，趋势线的缩放事件 */
    async zoomEvent() {
      // 滚动鼠标，暂不做任何操作，所以下列代码注释
      /* let startTime
      let endTime
      if (this.search.status === 0) {
        this.search.status = 1
        endTime = moment(Date.now()).format('YYYY-MM-DD HH:mm:ss')
        const ts = this.computedTimeSpan(this.search.timeSpan)
        startTime = moment(endTime)
          .subtract(ts.value, ts.date)
          .format('YYYY-MM-DD HH:mm:ss')
      } else {
        startTime = this.search.time[0]
        endTime = this.search.time[1]
      }
      if (params.batch.length === 1) {
        const interval = (moment(endTime).valueOf() - moment(startTime).valueOf()) / 4
        const xMin = moment(startTime).valueOf() + interval * (params.batch[0].start / 100)
        const xMax = moment(endTime).valueOf() - interval * (1 - params.batch[0].end / 100)
        this.search.time = [
          moment(xMin).format('YYYY-MM-DD HH:mm:ss'),
          moment(xMax).format('YYYY-MM-DD HH:mm:ss'),
        ]
      } else {
        this.search.time = [
          moment(params.batch[0].startValue).format('YYYY-MM-DD HH:mm:ss'),
          moment(params.batch[0].endValue).format('YYYY-MM-DD HH:mm:ss'),
        ]
      }
      this.chartTimer = false
      this.tableTimer = false
      const zoonLineData = await this.getTrendLine()
      this.createLine(zoonLineData)
      this.getTableData(false) */
    },
    // 生成趋势折线图
    createLine(lineData) {
      /* this.echartOption.toolbox = {
        show: true,
        feature: {
          dataZoom: {
            show: true,
            icon: {
              // zoom: 'image://images/refresh.png',
              back: 'image://images/null.png',
            },
          },
          restore: {
            show: true,
            title: '复原',
            // icon: 'image://images/null.png',
            icon: 'http://192.168.80.131:8080/img/bl-logo.fd294b2d.jpg',
            onclick: () => {
              this.search.status = this.restoreCondition.status
              this.search.time = this.restoreCondition.date
              this.switchChange(this.search.status)
            },
          },
        },
        iconStyle: {
          emphasis: {
            textPadding: 15,
          },
        },
      } */

      // this.$echarts.init(document.getElementById('chartLine'), 'macarons').dispose()
      // this.chartLine = this.$echarts.init(document.getElementById('chartLine'), 'macarons')
      this.chartLine.on('datazoom', this.zoomEvent)
      if (lineData && lineData.length) {
        this.echartOption.yAxis = []
      } else {
        this.echartOption.yAxis = [
          {
            type: 'value',
            splitLine: {
              show: false,
              lineStyle: {
                color: '#38585e',
                type: 'dashed',
              },
            },
          },
        ]
      }
      this.echartOption.series = []
      const currentTime = Date.now()
      /* 实时模式 */
      if (this.search.status * 1 === 0) {
        _.forEach(lineData, (o, i) => {
          if (o.values.length) {
            let data = _.map(o.values, (u) => {
              let val = u.value
              if (!Number.isInteger(val) && val) {
                val = (val * 1).toFixed(4)
              }
              if (!val) {
                val = 0
              }
              return [currentTime, val]
            })
            const index = _.findIndex(this.trendTableData, { tagId: o.measuringPointId * 1 })
            const point = this.trendTableData[index]
            // console.log('trendTableData中找到的行数据', point)
            // console.log('this.trendTableData', this.trendTableData)
            data = data.map((item) => {
              return [item[0], (item[1] * 1).toFixed(4)]
            })
            this.echartOption.series.push({
              name: point.name,
              tagId: o.measuringPointId * 1,
              type: 'line',
              data,
              lineStyle: {
                width: Number(point.lineWidth),
                type: point.lineStyle,
              },
              yAxisIndex: i,
            })

            this.echartOption.color[i] = point.color

            const seriesItemIndex = _.findIndex(this.echartOption.series, {
              tagId: o.measuringPointId * 1,
            })
            /* 拿到 this.echartOption.series[seriesItemIndex].data里面的数据，里面的数据格式是数组，[时间戳，值] */
            const seriesItemValueData = this.echartOption.series[seriesItemIndex].data.map(
              (item) => {
                return item[1]
              }
            )
            const yAxisMinValue = Math.min(...seriesItemValueData) * 0.95
            const yAxisMaxValue = Math.max(...seriesItemValueData) * 1.05
            this.echartOption.yAxis.push({
              min: yAxisMinValue,
              max: yAxisMaxValue,
              type: 'value',
              splitLine: {
                show: false,
                lineStyle: {
                  color: '#38585e',
                  type: 'dashed',
                },
              },
              show: i === 0,
              position: 'left',
              axisLabel: {
                show: false,
              },
              axisTick: {
                show: false,
              },
            })
          }
        })
      } else {
        /* 历史模式 */
        this.handleHistoryModeEcharts(lineData)
      }
      this.setXAxisInterval()

      this.chartLine.setOption(this.echartOption)
      /* 实时查看模式，持续更新折线图 */
      if (this.search.status * 1 === 0) {
        this.updateLine()
      }
    },
    /* 历史查看模式-生成折线图的数据处理 */
    handleHistoryModeEcharts(lineData) {
      if (Array.isArray(this.selected) && this.selected.length > 0 && lineData.length > 0) {
        this.selected.forEach((selectedItem, index) => {
          const itemTagId = selectedItem.tagId
          const seriesItemData = lineData.map((item) => {
            let val = item[itemTagId] * 1
            if (!Number.isInteger(val) && val) {
              val = (val * 1).toFixed(4)
            }
            if (!val) {
              val = 0
            }
            return [item.time * 1000, val]
          })
          // const index = _.findIndex(this.trendTableData, { tagId: o.measuringPointId * 1 })
          // const point = this.trendTableData[index]

          // 如果第一条数据的时间比搜索的开始时间大，那么补一条值为null的数据到最前面；同理，结束时间也需要补到结尾
          const startTimeCompare =
            seriesItemData[seriesItemData.length - 1][0] - dayjs(this.search.time[0]).valueOf() > 0
          const endTimeCompare = seriesItemData[0][0] - dayjs(this.search.time[1]).valueOf() < 0
          if (startTimeCompare) {
            seriesItemData.push([dayjs(this.search.time[0]).valueOf(), null])
          }
          if (endTimeCompare) {
            seriesItemData.unshift([dayjs(this.search.time[1]).valueOf(), null])
          }
          this.echartOption.series.push({
            name: selectedItem.name,
            tagId: selectedItem.tagId,
            type: 'line',
            data: seriesItemData,
            lineStyle: {
              width: Number(selectedItem.lineWidth),
              type: selectedItem.lineStyle,
            },
            yAxisIndex: index,
          })

          this.echartOption.color[index] = selectedItem.color
          this.echartOption.yAxis.push({
            min:
              selectedItem.minSection !== ''
                ? Number(selectedItem.minSection)
                : selectedItem.MinValue * 0.95,
            max:
              selectedItem.maxSection !== ''
                ? Number(selectedItem.maxSection)
                : selectedItem.MaxValue * 1.05,
            type: 'value',
            splitLine: {
              show: false,
              lineStyle: {
                color: '#38585e',
                type: 'dashed',
              },
            },
            // show: index === 0,
            position: 'left',
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          })
        })
      }
    },
    /* 设置x轴的时间刻度 */
    setXAxisInterval() {
      let maxVal = 0
      let minVal = 0
      _.forEach(this.echartOption.series, (item) => {
        const currentItemData = item.data
        if (this.search.status * 1 === 1) {
          minVal = currentItemData.length > 0 ? currentItemData[currentItemData.length - 1][0] : 0
          maxVal = currentItemData.length > 0 ? currentItemData[0][0] : 0
          /* 如果这一项的时间最小值比之前的值更小，则重新赋值 */
          if (currentItemData.length && currentItemData[currentItemData.length - 1][0] < minVal) {
            minVal = currentItemData[currentItemData.length - 1][0]
          }
          if (currentItemData.length && currentItemData[currentItemData.length - 1][0] > maxVal) {
            maxVal = currentItemData[0][0]
          }
        } else {
          /* 实时模式，最新的数据会添加到数组的最后,所以时间轴(即横轴)第一项是最小时间，最后一项是最新(也是最大)的时间 */
          if (minVal === 0 || (currentItemData.length && currentItemData[0][0] < minVal)) {
            minVal = currentItemData.length > 0 ? currentItemData[0][0] : 0
          }
          if (currentItemData.length && currentItemData[currentItemData.length - 1][0] > maxVal) {
            maxVal = currentItemData[currentItemData.length - 1][0]
          }
        }
      })
      const isSetInvervalVal = (maxVal - minVal) / 4 >= 1000
      if (isSetInvervalVal) {
        this.echartOption.xAxis.interval = (maxVal - minVal) / 4
      }
    },
    /* 获取测点趋势折线图数据 */
    async getTrendLine() {
      /* 获取已勾选的测点ID */
      // console.log('this.selected', this.selected)
      const tagsId = this.selected.map((item) => {
        return item.tagId * 1
      })
      /* 实时查看模式请求参数 */
      const paramsOne = {
        ids: tagsId.join(','),
        pagesize: 1000,
        maxResultCount: 1000,
      }
      /* 历史查看请求参数 */
      // 历史模式，根据查询时间，自动切换颗粒度
      if (!this.search.status * 1 === 0) {
        this.autoSwitchTimeUnit()
      }
      const paramsTwo = {
        interval: this.computedInterval(this.search.intervalUnit) * this.search.interval,
        ids: tagsId.map((item) => {
          return String(item)
        }),
        startTimeStamp: (moment(this.search.time[0]).valueOf() / 1000).toFixed(0) * 1,
        endTimeStamp: (moment(this.search.time[1]).valueOf() / 1000).toFixed(0) * 1,
        maxResultCount: 1000, // 不能大于1000
        skipCount: 0,
      }
      let err
      let res
      if (this.search.status * 1 === 0) {
        // 实时查看模式
        ;[err, res] = await iotApi.getValueForMeasuringPoints(paramsOne)
      } else {
        // 历史查看模式
        // 对查询时间段做限制，最大30天
        const startTime = new Date(this.search.time[0]).getTime()
        const endTime = new Date(this.search.time[1]).getTime()
        const gap = endTime - startTime > 30 * 24 * 60 * 60 * 1000 // 开始、结束时间跨度是否大于30天
        if (gap) {
          this.$message.warning('时间最大选择区间为30天!')
          return
        }
        ;[err, res] = await iotApi.getDivideValueListForMeasuringPoints({
          body: paramsTwo,
        })
        // console.log(res)
      }
      if (!err) {
        /* 历史查看模式接口返回的数据是JSON格式，需要解析 */
        return this.search.status * 1 === 0 ? res.data : JSON.parse(res.data)
      }
      if (err) {
        this.$message.warning('系统异常！')
      }
      return []
    },
    /**
     * 获取测点表格数据
     * @param {*} isUpdate 是否更新折线图 Y 轴的最小值与最大值
     */
    async getTableData(isUpdate) {
      let startTime
      let endTime
      if (this.search.status * 1 === 0) {
        const minArr = []
        const maxArr = []
        _.forEach(this.echartOption.series, (o) => {
          if (o.data.length) {
            minArr.push(o.data[0][0])
            maxArr.push(o.data[o.data.length - 1][0])
          }
        })
        startTime = moment(_.min(minArr)).format('YYYY-MM-DD HH:mm:ss')
        endTime = moment(_.max(maxArr)).format('YYYY-MM-DD HH:mm:ss')
      } else {
        startTime = this.search.time[0]
        endTime = this.search.time[1]
      }
      const intervalVal = (moment(endTime).valueOf() - moment(startTime).valueOf()) / 1000 / 60

      /* measuringPointApi.statistics只能获取到最大值、最小值、平均值, 当前值需要调用实时获取的接口 */
      const [err, res] = await iotApi.statistics({
        intervalMinutes: Math.ceil(intervalVal.toFixed(1)),
        ids: _.map(this.trendTableData, (o) => {
          return o.tagId * 1
        }).join(','),
        startTime: (moment(startTime).valueOf() / 1000).toFixed(0) - 2 * 60,
        endTime: (moment(endTime).valueOf() / 1000).toFixed(0),
      })
      if (!err && !_.isNil(res)) {
        // console.log('this.trendTableData', this.trendTableData)
        // console.log('------res', res)
        if (Array.isArray(res.statisticsValues) && res.statisticsValues.length === 0) {
          return
        }
        _.forEach(this.trendTableData, (o) => {
          /* 在res.data中找到 tag_id = o.tagId 的数据；如果未找到，返回undefined */
          const data = _.find(res.statisticsValues, { measuringPointId: String(o.tagId) })
          if (data) {
            const statisticsValues = data.values
            // res.data.statisticsValues里面返回的数据可能有多条，所以需要拿出每条数据的最大值，最小值
            const minValueList = statisticsValues.map((elem) => {
              return elem.minValue
            })
            const maxValueList = statisticsValues.map((elem) => {
              return elem.maxValue
            })
            const MINVALUE = Math.min(...minValueList)
            const MAXVALUE = Math.max(...maxValueList)
            // console.log('minValueList', minValueList)
            // console.log('maxValueList', maxValueList)
            // console.log('MINVALUE', MINVALUE)
            // console.log('MAXVALUE', MAXVALUE)

            const itemData = data.values[0]
            o.currentValue = itemData.values
            o.maxValue = itemData.maxValue
            o.minValue = itemData.minValue
            o.avg = itemData.avgValue
            const line = _.find(this.echartOption.series, { tagId: o.tagId })
            const min = MINVALUE ? _.round(MINVALUE * (MINVALUE > 0 ? 0.95 : 1.05), 2) : 0
            const max = MAXVALUE ? _.round(MAXVALUE * (MAXVALUE > 0 ? 1.05 : 0.95), 2) : 0
            if (line) {
              /* 是否更新折线图里折线 y 轴的最小值和最大值 */
              if (isUpdate) {
                // console.log('isUpdate-true')
                this.echartOption.yAxis[line.yAxisIndex].min = _.isNumber(min) ? min : 0
                this.echartOption.yAxis[line.yAxisIndex].max = _.isNumber(max) ? max : 0
                this.chartLine.setOption({
                  yAxis: this.echartOption.yAxis,
                })
              } else {
                // console.log('isUpdate-false')
                // console.log('table-item-o', o)
                o.minSection = _.isNumber(min) ? min : 0
                o.maxSection = _.isNumber(max) ? max : 0
                this.echartOption.yAxis[line.yAxisIndex].min = _.isNumber(min) ? min : 0
                this.echartOption.yAxis[line.yAxisIndex].max = _.isNumber(max) ? max : 0
                this.chartLine.setOption({
                  yAxis: this.echartOption.yAxis,
                })
              }
            }
          }
        })
      }

      /* 实时模式持续查询表格数据 */
      if (this.search.status * 1 === 0) {
        this.getActualTable()
        _.forEach(this.trendTableData, (o) => {
          /* 在res.data中找到 tag_id = o.tagId 的数据；如果未找到，返回undefined */
          const item = _.find(this.echartOption.series, { tagId: o.tagId * 1 })
          if (item) {
            const itemData = item.data[item.data.length - 1]
            o.currentValue = itemData[1] || ''
          }
        })
      } else {
        /* 调用实时查看模式折线图的接口获取到最新值赋值给表格里的当前值 */
        const tagIds = this.selected
          .map((item) => {
            return item.tagId
          })
          .join(',')
        const [err, realTimeRes] = await iotApi.getValueForMeasuringPoints({ ids: tagIds })
        if (!err && !_.isNil(realTimeRes)) {
          _.forEach(this.trendTableData, (o) => {
            /* 在res.data中找到 tag_id = o.tagId 的数据；如果未找到，返回undefined */
            const data = _.find(realTimeRes.data, { measuringPointId: String(o.tagId) })
            // console.log(data)
            if (data) {
              const itemData = data.values[0]
              o.currentValue = itemData.value || ''
            }
          })
        }
      }
    },
    /* 计算颗粒度的时间间隔interval */
    computedInterval(date) {
      let interval = 1
      if (date === 0) {
        interval = 1
      } else if (date === 1) {
        interval = 60
      } else if (date === 2) {
        interval = 60 * 60
      } else if (date === 3) {
        interval = 60 * 60 * 24
      }
      return interval
    },
    /* 计算时间跨度(快速选取后，计算出开始/结束时间) */
    computedTimeSpan(span) {
      let time = null
      switch (span) {
        case 1:
          time = {
            value: 30,
            date: 'minutes',
          }
          break
        case 2:
          time = {
            value: 1,
            date: 'hours',
          }
          break
        case 3:
          time = {
            value: 4,
            date: 'hours',
          }
          break
        case 4:
          time = {
            value: 8,
            date: 'hours',
          }
          break
        case 5:
          time = {
            value: 1,
            date: 'days',
          }
          break
        case 6:
          time = {
            value: 7,
            date: 'days',
          }
          break
        default:
          time = {
            value: 10,
            date: 'minutes',
          }
          break
      }
      return time
    },
    /* 勾选、去除勾选表格测点 */
    tableSelectChange(selected) {
      if (!this.trendDialog) return
      if (this.selected.length === 1 && selected.length === 0) {
        this.$message.warning('最少勾选一个测点!')
        /* this.$refs.trendTable是获取到引入的组件；、
           this.$refs.trendTable.$refs.trendTable是获取到组件里面的el-table
           toggleRowSelection会触发selection-change事件 */
        this.$refs.trendTable.$refs.trendTable.toggleRowSelection(this.selected[0])
        return
      }
      /* 如果是手动勾选表格里的测点触发的,这里的赋值是正常流程；
         如果是handleSelect中触发的，相当于重复赋值了, 即 this.selected = this.selected
      */
      this.selected = selected
      this.chartLine && this.chartLine.clear() // 重新查询前把图表清空
      this.switchChange(this.search.status) // 把数据查看模式传递进去(实时 = 0、历史 = 1，两种模式)
    },
    /* 保存y轴自定义 */
    saveYAxis(data) {
      // console.log('this.echartOption.series---', this.echartOption.series)
      // console.log('row--', data)
      const index = _.find(this.echartOption.series, { tagId: data.tagId }).yAxisIndex
      // 如果最小值大于最大值，给出提示
      if (data.maxSection * 1 <= data.minSection * 1) {
        this.$message.warning('下限不能大于等于上限')
        return
      }
      if (!this.echartOption.yAxis[index]) {
        return
      }
      if (data.maxSection !== '' && data.minSection !== '') {
        this.echartOption.yAxis[index].max = Number(data.maxSection)
        this.echartOption.yAxis[index].min = Number(data.minSection)
      } else if (data.maxSection !== '' && data.minSection === '') {
        this.echartOption.yAxis[index].max = Number(data.maxSection)
        delete this.echartOption.yAxis[index].min
      } else if (data.minSection !== '' && data.maxSection === '') {
        this.echartOption.yAxis[index].min = Number(data.minSection)
        delete this.echartOption.yAxis[index].max
      } else {
        delete this.echartOption.yAxis[index].min
        delete this.echartOption.yAxis[index].max
      }
      this.chartLine.setOption({
        yAxis: this.echartOption.yAxis,
      })
    },
    /* 更新曲线数据 */
    async updateLine() {
      if (this.selected.length === 0) {
        this.chartTimer = false
        return
      }
      /* 点击了关闭弹窗，不再往下走 */
      if (!this.chartTimer) {
        return
      }
      /* 图表中的测点数等于选中的测点数才继续 update */
      // console.log('this.echartOption.series', this.echartOption.series)
      // console.log('this.selected', this.selected)
      // if (this.echartOption.series.length !== this.selected.length) {
      //   return
      // }
      const newData = await this.getTrendLine()
      const currentTime = Date.now()
      _.forEach(newData, (o, i) => {
        if (o && o.values.length) {
          let val = o.values[0].value
          if (!Number.isInteger(val) && val) {
            val = (val * 1).toFixed(4)
          }
          if (!val) {
            val = 0
          }
          const data = [currentTime, val] // 由于接口返回的时间戳都是同一个值，所以以接口查询的时间为准
          // const idx = _.findIndex(this.echartOption.series, { tagId: o.measuringPointId * 1 }) // 在表格中找到与该测点tagId相等的索引
          // /* 通过idx拿到图表中该测点的数据 */
          // const seriesData = this.echartOption.series[idx].data
          // /* 实时模式，一个测点，接口只返回一条数据，所以200条内累计添加进折线图； 等于200条时，移除第一条数据，把最新的添加到结尾 */
          // if (idx > -1) {
          //   seriesData.push(data)
          // }
          // if (seriesData.length >= 200) {
          //   seriesData.shift()
          // }

          let idx = -1
          for (const [index, item] of this.echartOption.series.entries()) {
            if (item.tagId === parseInt(o.measuringPointId)) {
              idx = index
            }
          }
          /* 通过idx拿到图表中该测点的数据 */
          if (idx > -1) {
            const seriesData = this.echartOption.series[idx].data
            /* 实时模式，一个测点，接口只返回一条数据，所以600条内累计添加进折线图； 等于600条时，移除第一条数据，把最新的添加到结尾 */
            seriesData.push(data)
            if (seriesData.length >= 200) {
              seriesData.shift()
            }
          }

          const seriesItemValueData = this.echartOption.series[i].data.map((item) => {
            return item[1] * 1
          })
          const yAxisMinValue = Math.min(...seriesItemValueData) * 0.95
          const yAxisMaxValue = Math.max(...seriesItemValueData) * 1.05

          this.echartOption.yAxis[i].min = yAxisMinValue
          this.echartOption.yAxis[i].max = yAxisMaxValue
        }
      })
      this.chartLine.setOption({
        series: this.echartOption.series,
        xAxis: this.echartOption.xAxis,
        yAxis: this.echartOption.yAxis,
      })
      this.setXAxisInterval()
      // console.log('updateLine====this.echartOption.series----', this.echartOption.series)
      this.getActualData()
    },
    /* 获取实时折线图数据并更新 */
    getActualData: _.debounce(async function i() {
      /* 如果折线图定时器标记为false，则不再持续请求折线图数据进行更新图表 */
      if (!this.chartTimer) return
      await this.updateLine()
      await this.getTableData(false)
    }, 1000),
    /* 获取表格数据 */
    getActualTable: _.debounce(async function i() {
      /* 如果表格定时器标记为false，则不再持续请求表格数据进行更新表格 */
      if (!this.tableTimer) return
      await this.getTableData(false)
    }, 1000),
    setMaxResize() {
      this.maxWidth = document.body.clientWidth - 200
      this.maxHeight = document.body.clientHeight - 130
    },
    resizestop() {
      this.$nextTick(() => {
        if (this.chartLine) {
          this.chartLine.resize()
        }
      })
    },
    // 颗粒度根据查询时间自动切换
    autoSwitchTimeUnit() {
      /* 切换逻辑，查询时间跨度秒数大于1000条 时间颗粒度数值 * 时间颗粒度单位，则自动改变颗粒度数值，不切换单位 */
      const startTime = moment(this.search.time[0]).valueOf() / 1000 // 秒数
      const endTime = moment(this.search.time[1]).valueOf() / 1000 // 秒数
      const secondGap = endTime - startTime
      const intervalSecond = this.computedInterval(this.search.intervalUnit) * this.search.interval // 查询的间隔秒数
      const count = secondGap - intervalSecond * 1000 // 判断查询时间内，在当前时间颗粒度下是否大于1000条

      if (count > 0) {
        if (this.search.intervalUnit === 0) {
          this.search.interval = Math.ceil(secondGap / 1 / 1000)
        }
        if (this.search.intervalUnit === 1) {
          this.search.interval = Math.ceil(secondGap / 60 / 1000)
        }
        if (this.search.intervalUnit === 2) {
          this.search.interval = Math.ceil(secondGap / (60 * 60) / 1000)
        }
        if (this.search.intervalUnit === 3) {
          this.search.interval = Math.ceil(secondGap / (60 * 60 * 24) / 1000)
        }
      }
    },
  },
  created() {
    this.setMaxResize()
    this.echartOption.tooltip.axisPointer.label.formatter = this.formatterFuns()
    this.echartOption.xAxis.axisLabel.formatter = this.formatterXAxis()
  },
  mounted() {
    // 弹框层dom更新完毕，判断trendDialog的值
    this.$nextTick(() => {
      if (this.trendDialog) {
        // 弹框内层dom更新完毕，获取图表dom
        this.$nextTick(() => {
          this.chartLine = this.$echarts.init(document.getElementById('chartLine'), 'macarons')
        })
        this.loadPropsMeasurePoints()
      }
    })
  },
  beforeDestroy() {
    this.chartTimer = false
    this.tableTimer = false
  },
}
</script>
<style scoped lang="scss">
@import './index.scss';
.trend-view-wrapper {
  position: fixed;
  top: 120px;
  bottom: 110px;
  left: 200px;
  right: 100px;
  // background: #103A44B2;
  border-radius: 10px;
  background-image: var(--dialogBgImg);
  background-size: 100% 100%;
  z-index: 9999;
}
</style>
